/**
 * Several people may hold a role; one is primary. Mirrors primaryHolder and
 * holdersOf in functions/src/billing/people.ts, so the screen names the same
 * person the server sends documents to.
 */
import type { Person } from './types';

export function primaryFor(people: Person[], role: string): Person | undefined {
  const holders = [...people].sort((a, b) => a.id.localeCompare(b.id)).filter((p) => p.roles.includes(role));
  return holders.find((p) => p.primaryRoles?.includes(role)) ?? holders[0];
}

/** Everybody holding a role, the primary first, then by name. */
export function holdersOf(people: Person[], role: string): Person[] {
  const primary = primaryFor(people, role);
  return people.filter((p) => p.roles.includes(role))
    .sort((a, b) => (a.id === primary?.id ? -1 : b.id === primary?.id ? 1 : a.name.localeCompare(b.name)));
}
